/**
 * The checked apps, as the `allow` list a new project will be created with.
 *
 * Split out of dialog-custom-template.tsx so it can be tested without importing Kobalte,
 * which throws when loaded outside a browser — the same reason dialog-custom-provider-form
 * and dialog-connect-provider-copy sit beside their dialogs.
 *
 * The dialog starts with NOTHING checked, so the user opts each app in.
 *
 * Checking every app returns EMPTY, which means "write no bindings file" rather than an
 * allow-list naming today's fourteen apps — so a project made with everything ticked still
 * picks up bundled apps that later versions add. Checking none also returns empty, but the
 * dialog refuses to submit in that state, so it never reaches project creation.
 */
export function allowAppIDsFor(apps: readonly { id: string }[], selected: ReadonlySet<string>): string[] {
  if (selected.size === 0 || selected.size >= apps.length) return []
  return apps.map((app) => app.id).filter((id) => selected.has(id))
}
